/** Generated by swagger-axios-codegen */
// korekty:
// 1) CONFIG.baseURL
// 2) dodanie brakujących inicjacji pól zależnie od typów

import axiosStatic, { AxiosPromise, AxiosInstance } from 'axios';
import CONFIG from '../cfg/config';
const qs = require('qs');

let serverUrl = () => {
  return CONFIG.apiURL;
}

export interface IRequestOptions {
  headers?: any;
}

interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
function axios(configs: IRequestConfig): AxiosPromise {
  return serviceOptions.axios ? serviceOptions.axios.request(configs) : axiosStatic(configs);
}

export class MenuService {

  static getMenu(
    params: {
      hotelId: string,
      aOperatorId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<AsortWWWMenuNagl>> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwMenuNagl';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      configs.data = null;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getHeaders(
    params: {
      hotelId: string,
      aOperatorId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<AsortMenuWiersze> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwMenuWiersz';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      configs.data = null;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getAsort(
    params: {
      hotelId: string,
      aOperatorId: number,
      aGrupaId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<AsortGrupyWiersze> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwGrupyWiersz';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aGrupaId: params['aGrupaId'] };
      configs.data = null;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getAsortFoto(
    params: {
      hotelId: string,
      aOperatorId: number,  
      aGrupaId: number   
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<AsortGrupyWiersze> {                        ////////////////////Rezerwacja
      return new Promise((resolve, reject) => {
        const configs: IRequestConfig = { ...options, method: 'get' };
        configs.headers = {
          ...options.headers,
          'Content-Type': 'application/json'
        };
        let url = serverUrl() + '/manager/dajAsortWwwGrupyWierszFoto';
        configs.url = url;
        configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aGrupaId: params['aGrupaId']};
        configs.data = null;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * kontakt
   */
  static getKontakt(
    params: {
      /**  */
      hotelId: string;
      /**  */
      operatorId: number;
      /**  */
      domena: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Kontakt> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/recepcjaDajWwwPortalInfo0';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        operatorId: params['operatorId'],
        domena: params['domena']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class BasketService {

  static sendBasket(
    params: {
      hotelId: string,
      aOperatorId: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwGrupyNagl';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      configs.data = null;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class RestaurantService {
  static getRestaurant(
    params: {
      /**  */
      hotelId: string;
      aOperatorId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<user> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/dajRestauracja/';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getInfo(
    params: {
      /**  */
      hotelId: string;
      aOperatorId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<WWWSprzedazInfo>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajWwwSprzedazInfo';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getFonts(
    params: {
      /**  */
      hotelId: string;
      operatorId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Fonts> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajCzcionki';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], operatorId: params['operatorId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // static getLogo(
  //   params: {
  //     /**  */
  //     hotelId: string;
  //     aOperatorId: number;
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<user> {
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };
  //     let url = serverUrl() + '/hotel/img/logo1';

  //     configs.url = url;
  //     configs.params = { hotelId: params['hotelId'] };
  //     let data = null;

  //     configs.data = data;
  //     axios(configs)
  //       .then(res => {
  //         console.log(res.request.responseURL)
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         reject(err);
  //       });
  //   });
  // }
}

export class portalService {
  /**
   * Zapoczatkowanie sesji
   */
  static openSession(
    params: {
      /**  */
      instanceId: string;
      /**  */
      hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/session';

      configs.url = url;
      configs.params = { instanceId: params['instanceId'], hotelId: params['hotelId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}


export class userService {
  static getUserInfo(
    params: {
      /**  */
      hotelId: string;
      aId: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<user> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajOperatorzy0';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aId: params['aId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class hotelService {
  /**
   * Podstawowe informacje na stronę
   */
  static getHotelInfo(
    params: {
      hotelId: string;
      lang?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webHotel> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        // nie - to serwer ma ustawić:       'Access-Control-Allow-Origin': '*', // cors
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/info';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
      let data = null;
      configs.data = data;
      axios(configs)
        .then(res => {
          /* test:
                    alert(url);
                    alert('dane odebrane ='+JSON.stringify(res.data))
                    alert(res.status);
                    alert(res.statusText);
                    alert(res.headers);
                    alert(res.config);
           */
          resolve(res.data);
        })
        .catch(err => {
          alert('Bad config?');
          //          alert('error:'+JSON.stringify(err))
          reject(err);
        });
    });
  }
  /**
   * Kontakt
   */
  static getHotelContact(
    params: {
      /**  */
      hotelId: string;
      lang?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webContact> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/contact';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPortalInfo(
    params: {
      hotelId: string;
      //operatorId: number;
      domena?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Info> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        // nie - to serwer ma ustawić:       'Access-Control-Allow-Origin': '*', // cors
        'Content-Type': 'application/json'
      };

      //odkomentować----------------------------------------
      let url = serverUrl() + '/obiekt/dajPortalInfo';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], domena: params['domena'] };
      let data = null;
      configs.data = data;
      //odkomentować----------------------------------------

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Bad config?');
          //          alert('error:'+JSON.stringify(err))
          reject(err);
        });
    });
  }
}

export class roomsService {
  /**
   * Dane pobierane z recepcja_dajWwwRodzajePokoi_Info + uzupełniane na stronie web...
   */
  static getRooms(
    params: {
      hotelId: string;
      lang?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webRooms> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/rooms';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], lang: params['lang'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * galeria zdjęć
   */
  static getGallery(
    params: {
      /**  */
      hotelId: string;
      /**  */
      roomCategory: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webRoomGallery> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/gallery';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], roomCategory: params['roomCategory'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * dostępność
   */
  static getDetails(
    params: {
      hotelId: string;
      lang?: string;
      roomCategory: string;
      dateFrom: string;
      dateTo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webRoomDetails> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/details';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        lang: params['lang'],
        roomCategory: params['roomCategory'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo']
      };
      let data = null;

      configs.data = data;
      //alert('wysyłam: '+JSON.stringify(configs))
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getCalendar(
    params: {
      /**  */
      hotelId: string;
      /**  */
      lang?: string;
      /**  */
      dateFrom: string;
      /**  */
      dateTo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webCalendar> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/portal/calendar';

      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'],
        lang: params['lang'],
        dateFrom: params['dateFrom'],
        dateTo: params['dateTo']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

/*export class bookService {
  /**
   * Dodanie nowej rezerwacji
   */
/*static reservNew(
  params: {
    /** Rezeracja pokoi */
/*body: Reservation;
} = <any>{},
options: IRequestOptions = {}
): Promise<ReservationId> {
return new Promise((resolve, reject) => {
const configs: IRequestConfig = { ...options, method: 'post' };
configs.headers = {
  ...options.headers,
  'Content-Type': 'application/json'
};
let url = serverUrl() + '/reserve/new';

configs.url = url;

let data = { ...params['body'] };

configs.data = data;
//      alert(JSON.stringify(configs));
axios(configs)
  .then(res => {
//        alert(JSON.stringify(res));
    resolve(res.data);
  })
  .catch(err => {
    //alert('Error!!');
    reject(err);
  });
});
}
}*/

export class bookService {
  // static orderNewPayment2(
  //   params: {
  //     /** Rezeracja wejscia */
  //     hotelId: string,
  //     aOperatorId: number,
  //     aKontrId: number,
  //     aKontrNazwa: string,
  //     aSpZaplaty: string,
  //     aInternetInfo: string,
  //     aLiczbaLosowa: string,
  //     aJSON: OrderAsort[],
  //     aPayWeb: number
  //     aZrodloWeb: number,
  //     aNIP: string,
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<ReservationId> {                        ////////////////////Rezerwacja
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };
  //     let url = serverUrl() + '/manager/fakturaKoszykDodaj2';
  //     configs.url = url;
  //     //console.log(url);
  //     //console.log(JSON.parse(params['aJSON']));
  //     let data: OrderAsort[] = [];

  //     for (const order of params['aJSON'])
  //       data.push(order);

  //     //console.log(JSON.stringify(data));
  //     configs.params = {
  //       hotelId: params['hotelId'],
  //       aOperatorId: params['aOperatorId'],
  //       aKontrId: params['aKontrId'],
  //       aKontrNazwa: params['aKontrNazwa'],
  //       aSpZaplaty: params['aSpZaplaty'],
  //       aInternetInfo: params['aInternetInfo'],
  //       aLiczbaLosowa: params['aLiczbaLosowa'],
  //       aZrodloWeb: params['aZrodloWeb'],
  //       aNIP: params['aNIP'],
  //       aPayWeb: params['aPayWeb'],
  //       aJSON: JSON.stringify(data)
  //     };
  //     configs.data = null;
  //     //console.log(JSON.stringify(configs));
  //     console.log(configs);
  //     //alert(JSON.stringify(configs));
  //     serviceOptions.axios ?
  //       serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
  //       axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
  //     axios(configs)
  //       .then(res => {
  //         //        alert(JSON.stringify(res));
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         //alert('Error!!');
  //         reject(err);
  //       });
  //   });
  // }

  static orderNewPayment3(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: number,
      aKontrId: number,
      aKontrNazwa: string,
      aSpZaplaty: string,
      aInternetInfo: string,
      aLiczbaLosowa: string,
      aPayWeb: number
      aZrodloWeb: number,
      aNIP: string,
      aJsonKoszyk: OrderAsort[],
      aJsonDostawa: any
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/fakturaKoszykDodaj3';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      let data: OrderAsort[] = [];

      for (const order of params['aJsonKoszyk'])
        data.push(order);

      //console.log(JSON.stringify(data));
      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aKontrId: params['aKontrId'],
        aKontrNazwa: params['aKontrNazwa'],
        aSpZaplaty: params['aSpZaplaty'],
        aInternetInfo: params['aInternetInfo'],
        aLiczbaLosowa: params['aLiczbaLosowa'],
        aZrodloWeb: params['aZrodloWeb'],
        aNIP: params['aNIP'],
        aPayWeb: params['aPayWeb'],
        aJsonKoszyk: JSON.stringify(data).replaceAll('/', ''),
        aJsonDostawa: JSON.stringify(params['aJsonDostawa'],),
      };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * Sprawdzenie salda
   */
  static balanceCheck(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aTelefon: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletyKarnetSaldo';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aTelefon: params['aTelefon'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      //serviceOptions.axios ?
      //serviceOptions.axios.defaults.paramsSerializer = function(params) { return qs.stringify(params) } :
      //axiosStatic.defaults.paramsSerializer = function(params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * listy z nazwiskami
   */
  static getSurnames(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aNazwisko: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Surnames> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletyKarnetyInfo';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aNazwisko: params['aNazwisko'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      //serviceOptions.axios ?
      //serviceOptions.axios.defaults.paramsSerializer = function(params) { return qs.stringify(params) } :
      //axiosStatic.defaults.paramsSerializer = function(params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /**
   * listy z nazwiskami
   */
  static getPassHistory(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aEkarta: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<PassHistory> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletyKarnetHistoriaInfo';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aEkarta: params['aEkarta'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      //serviceOptions.axios ?
      //serviceOptions.axios.defaults.paramsSerializer = function(params) { return qs.stringify(params) } :
      //axiosStatic.defaults.paramsSerializer = function(params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  /*
  Odpytywanie o stan płatności co interwał czasowy
 */
  static ticketHeaderState(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aDokNr: number;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ticketHeaders> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletyDokNagl';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDokNr: params['aDokNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  // static reservConfirm2(
  //   params: {
  //     hotelId: string,
  //     aOperatorId: number,
  //     aDokNr: number,
  //     aPayWeb: number
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<ReservationId> {     ////                   
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };

  //     let url = serverUrl() + '/manager/fakturaKoszykPotwierdz2';
  //     configs.url = url;

  //     configs.params = {
  //       hotelId: params['hotelId'],
  //       aOperatorId: params['aOperatorId'],
  //       aDokNr: params['aDokNr'],
  //       aPayWeb: params['aPayWeb'],
  //     };
  //     configs.data = null;

  //     axios(configs)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         //alert('Error!!');
  //         reject(err);
  //       });
  //   });
  // }

  static reservConfirm3(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDokNr: number,
      aPayWeb: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {     ////                   
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = serverUrl() + '/manager/fakturaKoszykPotwierdz3';
      configs.url = url;

      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDokNr: params['aDokNr'],
        aPayWeb: params['aPayWeb'],
      };
      configs.data = null;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  // static reservCancel2(
  //   params: {
  //     hotelId: string,
  //     aOperatorId: number,
  //     aDokNr: number,
  //     aPayWeb: number
  //   } = <any>{},
  //   options: IRequestOptions = {}
  // ): Promise<ReservationId> {     ////                   
  //   return new Promise((resolve, reject) => {
  //     const configs: IRequestConfig = { ...options, method: 'get' };
  //     configs.headers = {
  //       ...options.headers,
  //       'Content-Type': 'application/json'
  //     };

  //     let url = serverUrl() + '/manager/fakturaKoszykAnuluj2';
  //     configs.url = url;

  //     configs.params = {
  //       hotelId: params['hotelId'],
  //       aOperatorId: params['aOperatorId'],
  //       aDokNr: params['aDokNr'],
  //       aPayWeb: params['aPayWeb'],
  //     };
  //     configs.data = null;

  //     axios(configs)
  //       .then(res => {
  //         resolve(res.data);
  //       })
  //       .catch(err => {
  //         //alert('Error!!');
  //         reject(err);
  //       });
  //   });
  // }

  static reservCancel3(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDokNr: number,
      aPayWeb: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<ReservationId> {     ////                   
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = serverUrl() + '/manager/fakturaKoszykAnuluj3';
      configs.url = url;

      configs.params = {
        hotelId: params['hotelId'],
        aOperatorId: params['aOperatorId'],
        aDokNr: params['aDokNr'],
        aPayWeb: params['aPayWeb'],
      };
      configs.data = null;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class payService {
  /**
   * wywołanie statusu płatności cashBill na serwerze, 
   * wynikiem jest status płatności
   */
  static getStatus(
    params: {
      /**  */
      hotelId: string,
      idPlatnosci: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<payStatus> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillStatus';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillStatus';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], idPlatnosci: params['idPlatnosci'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * wywołanie testu kanałow płatności cashBill ze serwera
   */
  static triggerTest(
    params: {
      /**  */
      hotelId: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<payTest1[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillTest';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillTest';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * wywołanie płatności cashBill na serwerze, 
   * wynikiem link do strony z płatnościami
   */
  static getPaymentUrl(
    params: {
      /**  */
      hotelId: string,
      dokNr: string,
      kwota: string,
      opis: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPayment> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillZaplac';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillZaplac';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'], kwota: params['kwota'], opis: params['opis'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getPaymentUrl1(
    params: {
      /**  */
      hotelId: string,
      dokNr: string,
      kwota: string,
      opis: string,
      returnUrl: string,
      negativeReturnUrl: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPayment> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/pay/payCashBillZaplac';
      let url = 'https://vsc24.net/vscSms/pay/payCashBillZaplac1';
      configs.url = url;
      configs.params = {
        hotelId: params['hotelId'], dokNr: params['dokNr'], kwota: params['kwota'], opis: params['opis'],
        returnUrl: params['returnUrl'], negativeReturnUrl: params['negativeReturnUrl']
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class reportService {
  /**
   * Otwarcie nowego raportu
   */
  static newReport(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDataOdDo: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoZrobStandardowy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDataOdDo: params['aDataOdDo'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getFirst(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoDajSumy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getTable(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoDajGrupyAsortymenty';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static endReport(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargZaCoZakoncz';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static newReportTime(
    params: {
      hotelId: string,
      aOperatorId: number,
      aDataOdDo: number,
      aOkresOd: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyZrobStandardowy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDataOdDo: params['aDataOdDo'], aOkresOd: params['aOkresOd'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getFirstTime(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyDajSumy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static getTableTime(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyDajOkresy';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static endReportTime(
    params: {
      hotelId: string,
      aOperatorId: number,
      aRaportNr: number,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/raporty/raportUtargJakiOkresyZakoncz';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRaportNr: params['aRaportNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      serviceOptions.axios ?
        serviceOptions.axios.defaults.paramsSerializer = function (params) { return qs.stringify(params) } :
        axiosStatic.defaults.paramsSerializer = function (params) { return qs.stringify(params) };
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class PDFService {
  /**
   * Dodanie nowej rezerwacji
   */
  static getPDFData(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aDokNr: number,
      aOK: any,
      //aJSON: Rezerwacja;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<PDFData> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBilety2Pdf';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDokNr: params['aDokNr'], aOK: params['aOK'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  static PDFClose(
    params: {
      /** Rezeracja wejscia */
      hotelId: string,
      aOperatorId: any,
      aDokNr: number,
      //aJSON: Rezerwacja;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<PDFData> {                        ////////////////////Rezerwacja
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/biletyZamknij';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['aJSON']));
      //let data = [{ ...params['aJSON'] }];
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDokNr: params['aDokNr'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          //        alert(JSON.stringify(res));
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class OfferService {

  //wczytanie nagłówków oferty
  static getOfferTableHeads(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webOfferTableHeads> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwGrupyNagl1';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(JSON.stringify(data));
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //wczytanie komurek oferty
  static getOfferTableRows(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webOfferTableRows> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajAsortWwwGrupyWiersz1';
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'] };
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class TicketService {

  //wczytanie danych biletów prawa tabela
  static getSessionTickets(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aSesjaId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {     //Invoices
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletySesjaRezerwacje';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aSesjaId: params['aSesjaId'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //wczytanie danych karnetów prawa tabela
  static getSessionKarnety(/////////////////////
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aSesjaId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {     //Invoices
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletySesjaKarnety';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aSesjaId: params['aSesjaId'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //wczytanie danych biletów
  static getTickets(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aManagerOK: number,
      aData: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<webTickets> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletySesjeDzien';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aManagerOK: params['aManagerOK'], aData: params['aData'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //sumaryczne dane o sesjach we wskazanym okresie (sprzedaż)
  static getSessionsSum(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aData: string,
      aIleDni: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<SessionsSum> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletySesjeDniSum';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aData: params['aData'], aIleDni: params['aIleDni'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //wiersze faktur dla wskazanej sesji
  static getSessionFkt(
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aSesjaId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Invoices> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/dajBiletySesjaFkt';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aSesjaId: params['aSesjaId'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //usunięcie jednego biletu
  static TicketCancel(/////////////////////
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aRezId: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {     //Invoices
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/biletAnulujWM';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aRezId: params['aRezId'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }

  //usunięcie kilku biletów
  static TicketsCancel(/////////////////////
    params: {
      /** parametry */
      hotelId: string,
      aOperatorId: number,
      aDokNr: number
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {     //Invoices
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/manager/biletyAnulujWM';   ////sprawdzić
      configs.url = url;
      //console.log(url);
      //console.log(JSON.parse(params['body']));
      //let data = [{ ...params['body'] }];       //sprawdzić
      //console.log(params);
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDokNr: params['aDokNr'] };  //sprawdzić
      configs.data = null;
      //console.log(JSON.stringify(configs));
      //console.log(configs);
      //alert(JSON.stringify(configs));
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          //alert('Error!!');
          reject(err);
        });
    });
  }
}

export class paymentService {
  /**
   * Zapoczatkowanie sesji
   */
  static getPaymentMethods(
    params: {
      /**  */
      shopId: string,
      lang?: string,
      //instanceId: string;
      //shopId: string;
      //lang?: string;
      /**  */
      // hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/cashBill';
      configs.url = url;
      configs.params = { hotelId: params['shopId'], lang: params['lang'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
     * Pobieranie url do platnosci
     */
  static getPaymentUrl(
    params: {
      /**  */
      hotelId: string,
      aOperatorId: number,
      aDokNr: number,
      aKwota: string
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<vscPayments> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/payWeb/vscCashBillPayment';
      configs.url = url;
      configs.params = { hotelId: params['hotelId'], aOperatorId: params['aOperatorId'], aDokNr: params['aDokNr'], aKwota: params['aKwota'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class gusService {
  /**
   * Szukaj Nip w GUS
   */
  static dajDanePoNip(
    params: {
      nip: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Nip> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = 'https://vsc24.net/vscSms/gus/dajDanePoNip/' + params['nip'];
      configs.url = url;
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class FcmNotification {
  static sendErrorLog(
    params: {
      hotelId: string;
      aplikacjaId: string;
      mobileNr: string;
      tekst: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };

      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/fcmAplikacjaWyslij';
      let url = 'https://vsc24.net/vscSms/fcm/fcmAplikacjaWyslij';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], aplikacjaId: params['aplikacjaId'], mobileNr: params['mobileNr'], tekst: params['tekst'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  static sendNotification(
    params: {
      hotelId: string;
      mobileNr: string;
      tekst: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/fcmWyslij';
      let url = 'https://vsc24.net/vscSms/fcm/fcmWyslij';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], tekst: params['tekst'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static sendToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenDodaj';
      let url = 'https://vsc24.net/vscSms/fcm/tokenDodaj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static deleteToken(
    params: {
      hotelId: string;
      mobileNr: string;
      token?: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      };
      //let url = 'http://test.vsc24.eu:8080/vscSms/fcm/tokenKasuj';
      let url = 'https://vsc24.net/vscSms/fcm/tokenKasuj';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class SerwisService {
  /**
   * Zapisanie stanu aplikacji do vscSerwis
   */
  static saveReport(
    params: {
      hotelId: string;
      ktoId: string;
      adresIP: string;
      opis: string;
      status: string;
      akcjaNr: string;
      akcjaOpis: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      let url = "https://vsc24.net/vscSerwis/serwis/zapiszRaport"

      configs.url = url;
      configs.params = {
        hotelId: params.hotelId, ktoId: params.ktoId, adresIP: params.adresIP,
        opis: params.opis, status: params.status, akcjaNr: params.akcjaNr, akcjaOpis: params.akcjaOpis
      };
      let data = null;
      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class FakturaVatService {

  static getHeader(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatHeder>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajFaktNagl';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getNotes(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatNotes>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + "/faktura/dajFaktNotesKlienta";

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableVat(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableVat>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajFaktVat';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableRows(
    params: {
      hotelId: string;
      dokNr: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableRow>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajFaktWiersz';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dokNr: params['dokNr'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getInstalacja(
    params: {
      hotelId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatInstalacja>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajInstalacje';

      configs.url = url;
      configs.params = { hotelId: params['hotelId']};
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getDokNr(
    params: {
      hotelId: string;
      pobytId: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatDokNr>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajPobytFaktDokNr';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], pobytId: params['pobytId'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableRowsFromTo(
    params: {
      hotelId: string;
      dataWystOd: string;
      dataWystDo: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableRowFromTo>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajFaktNaglWierszeDataWyst';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], dataWystOd: params['dataWystOd'], dataWystDo: params['dataWystDo']};
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static getTableRowsPhone(
    params: {
      hotelId: string;
      telefon: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<VatTableRowFromTo>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscXyz" + '/faktura/dajFaktNaglWierszeTelefon';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], telefon: params['telefon']};
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class ZamowService {

  static dajZamOsobaInfoOK(
    params: {
      zamOsobaId: string;
      zamFirmaId: string;
      zamOddzialId: string;
      telefon: string;
      lokalPrzydzial: string;
      data: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<ZamOsobaInfoOK>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = "https://vsc24.net/vscZamow" + '/zamow/dajZamOsobaInfoOK';

      configs.url = url;
      configs.params = { 
        zamOsobaId: params['zamOsobaId'],
        zamFirmaId: params['zamFirmaId'],
        zamOddzialId: params['zamOddzialId'],
        telefon: params['telefon'],
        lokalPrzydzial: params['lokalPrzydzial'],
        data: params['data'],
      };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export class user {

  ident_oper: string = '';


  nazwisko: string = '';


  operator_id: string = '';

  constructor(data?: any) {
    if (data) {
      this['ident_oper'] = data['ident_oper'];
      this['nazwisko'] = data['nazwisko'];
      this['operator_id'] = data['operator_id'];
    }
  }
}

export class webHotel {
  /** recepcja@hotelnowydwor.pl */
  email: string = '';

  /** +48 17 856 09 90 */
  phone: string = '';

  /** +48 17 860 02 17 */
  fax: string = '';

  /** Świlcza 146E 36-072 Świlcza /k. Rzeszowa */
  address: string = '';

  /** 50.067683E, 21.922610N */
  gps: string = '';

  /** tu jest info o hotelu w <FONT Color=#FF0000>
j�zyku polski</FONT>
<FONT Color=#000000><B>
.</B>
<BR>
</FONT>
 */
  panel: string = '';

  constructor(data?: any) {
    if (data) {
      this['email'] = data['email'];
      this['phone'] = data['phone'];
      this['fax'] = data['fax'];
      this['address'] = data['address'];
      this['gps'] = data['gps'];
      this['panel'] = data['panel'];
    }
  }
}

export class webContact {
  /** recepcja@hotelnowydwor.pl */
  email: string = '';

  /** +48 17 856 09 90 */
  phone: string = '';

  constructor(data?: any) {
    if (data) {
      this['email'] = data['email'];
      this['phone'] = data['phone'];
    }
  }
}

export class webRoom {
  id: number = 0;

  /** www_rodz_pokoi_id */
  src_id: number = 0;

  /** rodz_pokoi - np. PKSN */
  roomCategory: string = '';

  /** ilość miejsc w pokoju ilosc_miejsc '2' */
  persons: number = 0;

  title: string = '';

  sentence: string = '';

  /** krótki opis na karcie (opis) Apartament SENATOR */
  short: string = '';

  /** dłuższy opis - rozwijany */
  long: string = '';


  /** cena_pokoj, - bez groszy '99999' */
  price: number = 0;

  /** cena_os1, - bez groszy '99999' */
  price1: number = 0;

  /** cena_os2, - bez groszy '99999' */
  price2: number = 0;

  /** cena_os3, - bez groszy '99999' */
  price3: number = 0;

  /** cena_os4, - bez groszy '99999' */
  price4: number = 0;

  /** cena_brak, - bez groszy '99999' */
  price_empty: number = 0;

  /** url obrazka 'img/rooms/ST1K/1.jpg' */
  image: string = '';

  /** opis HTML - np 'telewior i internet w pokoju', */
  options: string = '';

  /** room1.ilosc_pokoi tego typu */
  roomsAvail: number = 0;

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['src_id'] = data['src_id'];
      this['roomCategory'] = data['roomCategory'];
      this['title'] = data['title'];
      this['sentence'] = data['sentence'];
      this['short'] = data['short'];
      this['long'] = data['long'];
      this['persons'] = data['persons'];
      this['price'] = data['price'];
      this['price1'] = data['price1'];
      this['price2'] = data['price2'];
      this['price3'] = data['price3'];
      this['price4'] = data['price4'];
      this['price_empty'] = data['price_empty'];
      this['image'] = data['image'];
      this['options'] = data['options'];
      this['roomsAvail'] = data['roomsAvail'];
    }
  }
}

export class webRooms {
  /** pokoje - do wyśietlenia na stronie internetowej */
  rooms: webRoom[] = [];

  constructor(data?: any) {
    if (data) {
      this['rooms'] = data['rooms'];
    }
  }
}

export class webRoomDetails {
  /** www_rodz_pokoi_id */
  id: number = 0;

  /** rodz_pokoi - np. PKSN */
  roomCategory: string = '';

  title: string = '';

  /** krótki opis na karcie (opis) Apartament SENATOR */
  short: string = '';

  /** ilość miejsc w pokoju ilosc_miejsc '2' */
  persons: number = 0;

  /** ilość pokoi tej kategorii */
  totalRooms: number = 0;

  /** ilość wolnych pokoi tej kategorii */
  vacantRooms: number = 0;

  /** cena_pokoj, - bez groszy '99999' */
  price: number = 0;

  /** cena_os1, - bez groszy '99999' */
  price1: number = 0;

  /** cena_os2, - bez groszy '99999' */
  price2: number = 0;

  /** cena_os3, - bez groszy '99999' */
  price3: number = 0;

  /** cena_os4, - bez groszy '99999' */
  price4: number = 0;

  /** cena_brak, - bez groszy '99999' */
  price_empty: number = 0;

  /** opcja do zaznaczenia 1 */
  checkOption1: string = '';

  /** opcja do zaznaczenia 2 */
  checkOption2: string = '';

  /** opcja do zaznaczenia 3 */
  checkOption3: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['roomCategory'] = data['roomCategory'];
      this['title'] = data['title'];
      this['short'] = data['short'];
      this['persons'] = data['persons'];
      this['totalRooms'] = data['totalRooms'];
      this['vacantRooms'] = data['vacantRooms'];
      this['price'] = data['price'];
      this['price1'] = data['price1'];
      this['price2'] = data['price2'];
      this['price3'] = data['price3'];
      this['price4'] = data['price4'];
      this['price_empty'] = data['price_empty'];
      this['checkOption1'] = data['checkOption1'];
      this['checkOption2'] = data['checkOption2'];
      this['checkOption3'] = data['checkOption3'];
    }
  }
}

export class image {
  /** url zdjęcia */
  url: string = '';

  /** url miniatury */
  thumbnails: string = '';

  /** krótki opis */
  alias: string = '';

  constructor(data?: any) {
    if (data) {
      this['url'] = data['url'];
      this['thumbnails'] = data['thumbnails'];
      this['alias'] = data['alias'];
    }
  }
}

export class webRoomGallery {
  /** rodz_pokoi - np. PKSN */
  roomCategory: string = '';

  /** dane o wolnych pokojach w danym dniu */
  images: image[] = [];

  constructor(data?: any) {
    if (data) {
      this['roomCategory'] = data['roomCategory'];
      this['images'] = data['images'];
    }
  }
}


export class ReservRoom {
  /** data zameldowania */
  check_in: string = '';

  /** data wymeldowania */
  check_out: string = '';

  /** kategoria pokoju */
  roomCategory: string = '';

  /** ilość miejsc */
  quantity: number = 0;

  /** opcja / cena za miejsce */
  price: number = 0;

  constructor(data?: any) {
    if (data) {
      this['check_in'] = data['check_in'];
      this['check_out'] = data['check_out'];
      this['roomCategory'] = data['roomCategory'];
      this['quantity'] = data['quantity'];
      this['price'] = data['price'];
    }
  }
}

export class Reservation {
  /** kod hotelu */
  hotelId: string = '';

  /** klucz dostępu */
  key: string = '';

  /** jezyk */
  lang: string = '';

  /** JAN */
  name: string = '';

  /** KOWALSKI */
  surname: string = '';

  /** kowalski.jan@gmail.com */
  email: string = '';

  /** 606257683 */
  phone: string = '';

  /** Miasto */
  company: string = '';

  /** Numer NIP */
  vatID: string = '';

  /** miejscwoość */
  city: string = '';

  /** uwag kilka kolegi wilka */
  remarks: string = '';

  reservations: ReservRoom[] = [];

  constructor(data?: any) {
    if (data) {
      this['hotelId'] = data['hotelId'];
      this['key'] = data['key'];
      this['lang'] = data['lang'];
      this['name'] = data['name'];
      this['email'] = data['email'];
      this['phone'] = data['phone'];
      this['company'] = data['company'];
      this['vatID'] = data['vatID'];
      this['city'] = data['city'];
      this['remarks'] = data['remarks'];
      this['reservations'] = data['reservations'];
    }
  }
}

/*export class ReservationId {
  /** identyfikator */
/*id: number = 0;

/** komunikat */
/*message: string = '';

constructor(data?: any) {
  if (data) {
    this['id'] = data['id'];
    this['message'] = data['message'];
  }
}
}*/

// Generated by https://quicktype.io

export class ReservationId {
  /** identyfikator */
  result: number[] = [];


  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class calendarRow {
  /** klucz (kategoria pokoju) */
  id: string = '';

  /** opis (pokój) - skala pionowa */
  info: string = '';

  /**  */
  color: string = '';

  /** dane o wolnych pokojach w danym dniu */
  days: string[] = [];

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['info'] = data['info'];
      this['color'] = data['color'];
      this['days'] = data['days'];
    }
  }
}

export class webCalendar {
  /** data początkowa */
  date: string = '';

  /** ilość dni */
  days: number = 0;

  /** dane dla pokojów */
  rows: calendarRow[] = [];

  constructor(data?: any) {
    if (data) {
      this['date'] = data['date'];
      this['days'] = data['days'];
      this['rows'] = data['rows'];
    }
  }
}

export class Rezerwacja {
  sesja_id: string = "";   //id sesji
  bilety_ilosc: string = "";
  wejscie: string = "";                    // 0/1  nie ma wejscia/jest
  wejscie_mag_id: string = "";       //dane z definicji dajAsortWwwGrupyWiersz1
  wejscie_asort_id: string = "";
  wejscie_asort_nazwa: string = "";
  wejscie_vat_stawka: string = "";
  wejscie_cena: string = "";
  wejscie_ilosc: string = "";       //ile wejsc
  wejscie_rodzaj: string = ""; //rodzaj wejscia: jednorazowe/dziecko/niepelnosprawny
  wejscie_wplata: string = ""; // część kwoty biletu, wpłacane od razu, reszta póżniej
  masaz: string = "";                     // jak wyżej ale masaz
  masaz_mag_id: string = "";
  masaz_asort_id: string = "";
  masaz_asort_nazwa: string = "";
  masaz_vat_stawka: string = "";
  masaz_cena: string = "";
  masaz_ilosc: string = "";
  karnet: string = "";
  karnet_doladowanie: string = "";
  kontr_nazwa: string = "";
  kontr_tel_nr: string = "";
  zrodlo_danych: string = "";

  /*UWAGI
  Jak brak wejscia, to wpisujemy "wejscie": "0"
  Jak brak masazu, to wpisujemy "masaz": "0"
  
  asort_id i pozostałe z definicji asortymentu
  
  wejscie_ilosc i masaz_ilosc to ilości wybrane przez Klienta*/


  constructor(data?: any) {
    if (data) {
      this['sesja_id'] = data['sesja_id'];
      this['bilety_ilosc'] = data['bilety_ilosc'];
      this['wejscie'] = data['wejscie'];
      this['wejscie_mag_id'] = data['wejscie_mag_id'];
      this['wejscie_asort_id'] = data['wejscie_asort_id'];
      this['wejscie_asort_nazwa'] = data['wejscie_asort_nazwa'];
      this['wejscie_vat_stawka'] = data['wejscie_vat_stawka'];
      this['wejscie_cena'] = data['wejscie_cena'];
      this['wejscie_ilosc'] = data['wejscie_ilosc'];
      this['masaz'] = data['masaz'];
      this['masaz_mag_id'] = data['masaz_mag_id'];
      this['masaz_asort_id'] = data['masaz_asort_id'];
      this['masaz_asort_nazwa'] = data['masaz_asort_nazwa'];
      this['masaz_vat_stawka'] = data['masaz_vat_stawka'];
      this['masaz_cena'] = data['masaz_cena'];
      this['masaz_ilosc'] = data['masaz_ilosc'];
      this['karnet'] = data['karnet'];
      this['karnet_doladowanie'] = data['karnet_doladowanie'];
      this['kontr_nazwa'] = data['kontr_nazwa'];
      this['kontr_tel_nr'] = data['kontr_tel_nr'];
      this['zrodlo_danych'] = data['zrodlo_danych'];
    }
  }
}

export class RezerwacjaUK {
  sesja_id: string = "";   //id sesji
  upominek: string = "";                    // 0/1  nie ma upominku/jest
  upominek_mag_id: string = "";       //dane z definicji dajAsortWwwGrupyWiersz1
  upominek_asort_id: string = "";
  upominek_asort_nazwa: string = "";
  upominek_vat_stawka: string = "";
  upominek_cena: string = "";
  upominek_ilosc: string = "";       //ile upominkow
  karnet: string = "";
  karnet_doladowanie: string = "";
  od_kogo_kontr_nazwa: string = "";
  od_kogo_kontr_tel_nr: string = "";
  dla_kogo_kontr_nazwa: string = "";
  dla_kogo_kontr_tel_nr: string = "";
  zrodlo_danych: string = "";

  /*UWAGI
  Jak brak wejscia, to wpisujemy "wejscie": "0"
  Jak brak masazu, to wpisujemy "masaz": "0"
  
  asort_id i pozostałe z definicji asortymentu
  
  wejscie_ilosc i masaz_ilosc to ilości wybrane przez Klienta*/


  constructor(data?: any) {
    if (data) {
      this['sesja_id'] = data['sesja_id'];
      this['upominek'] = data['upominek'];
      this['upominek_mag_id'] = data['upominek_mag_id'];
      this['upominek_asort_id'] = data['upominek_asort_id'];
      this['upominek_asort_nazwa'] = data['upominek_asort_nazwa'];
      this['upominek_vat_stawka'] = data['upominek_vat_stawka'];
      this['upominek_cena'] = data['upominek_cena'];
      this['upominek_ilosc'] = data['upominek_ilosc'];
      this['karnet'] = data['karnet'];
      this['karnet_doladowanie'] = data['karnet_doladowanie'];
      this['od_kogo_kontr_nazwa'] = data['od_kogo_kontr_nazwa'];
      this['od_kogo_kontr_tel_nr'] = data['od_kogo_kontr_tel_nr'];
      this['dla_kogo_kontr_nazwa'] = data['dla_kogo_kontr_nazwa'];
      this['dla_kogo_kontr_tel_nr'] = data['dla_kogo_kontr_tel_nr'];
      this['zrodlo_danych'] = data['zrodlo_danych'];
    }
  }
}

export class OfferTableHead {
  /** grupa id */
  grupa_id: number = 0;

  /** nagłówek tabeli */
  opis: string = '';

  /** kolejność tabeli */
  kolejnosc: number = 0;

  constructor(data?: any) {
    if (data) {
      this['grupa_id'] = data['grupa_id'];
      this['opis'] = data['opis'];
      this['kolejnosc'] = data['kolejnosc'];
    }
  }
}

export class webOfferTableHeads {
  /** sesje - do wyśietlenia na stronie internetowej */
  result: OfferTableHead[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class OfferTableRow {
  /** grupa id */
  grupa_id: number = 0;

  /** grupa liczba porządkowa */
  grupa_lp: number = 0;

  /** ??? */
  mag_id: number = 0;

  /** ??? */
  asort_id: number = 0;

  /** ??? */
  asort_nazwa: string = '';

  /** ??? */
  jm: string = '';

  /** stawka vat */
  vat_stawka: string = '';

  /** cena */
  cena: string = '';

  /** waluta */
  waluta: string = '';

  /** kolejność w tabeli */
  kolejnosc: number = 0;

  /** ??? poprawny typ? */
  tag_01: string = '';
  /** ??? poprawny typ? */
  tag_02: string = '';
  /** ??? poprawny typ? */
  tag_03: string = '';
  /** ??? poprawny typ? */
  tag_04: string = '';
  /** ??? poprawny typ? */
  tag_05: string = '';
  /** ??? poprawny typ? */
  tag_06: string = '';
  /** ??? poprawny typ? */
  tag_07: string = '';
  /** ??? poprawny typ? */
  tag_08: string = '';
  /** ??? poprawny typ? */
  tag_09: string = '';
  /** ??? poprawny typ? */
  tag_10: string = '';
  /** ??? poprawny typ? */
  tag_11: string = '';
  /** ??? poprawny typ? */
  tag_12: string = '';
  /** ??? poprawny typ? */
  tag_13: string = '';
  /** ??? poprawny typ? */
  tag_14: string = '';
  /** ??? poprawny typ? */
  tag_15: string = '';

  constructor(data?: any) {
    if (data) {
      this['grupa_id'] = data['grupa_id'];
      this['mag_id'] = data['mag_id'];
      this['asort_id'] = data['asort_id'];
      this['asort_nazwa'] = data['asort_nazwa'];
      this['jm'] = data['jm'];
      this['vat_stawka'] = data['vat_stawka'];
      this['cena'] = data['cena'];
      this['waluta'] = data['waluta'];
      this['kolejnosc'] = data['kolejnosc'];
      this['tag_01'] = data['tag_01'];
      this['tag_02'] = data['tag_02'];
      this['tag_03'] = data['tag_03'];
      this['tag_04'] = data['tag_04'];
      this['tag_05'] = data['tag_05'];
      this['tag_06'] = data['tag_06'];
      this['tag_07'] = data['tag_07'];
      this['tag_08'] = data['tag_08'];
      this['tag_09'] = data['tag_09'];
      this['tag_10'] = data['tag_10'];
      this['tag_11'] = data['tag_11'];
      this['tag_12'] = data['tag_12'];
      this['tag_13'] = data['tag_13'];
      this['tag_14'] = data['tag_14'];
      this['tag_15'] = data['tag_15'];
    }
  }
}

export class webOfferTableRows {
  /** sesje - do wyśietlenia na stronie internetowej */
  result: OfferTableRow[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class Ticket {
  /** grupa id */
  sesja_nr: string = '';

  /** nagłówek tabeli */
  opis: string = '';

  /** kolejność tabeli */
  data: number = 0;

  /** kolejność tabeli */
  data_godz_min_od: string = '';

  /** kolejność tabeli */
  data_godz_min_do: string = '';

  /** kolejność tabeli */
  godz_min_od: string = '';

  /** kolejność tabeli */
  godz_min_do: string = '';

  /** kolejność tabeli */
  godz_od: string = '';

  /** kolejność tabeli */
  min_od: string = '';

  /** kolejność tabeli */
  godz_do: string = '';

  /** kolejność tabeli */
  min_do: string = '';

  /** kolejność tabeli */
  ilosc_biletow_kontrola: string = '';

  /** kolejność tabeli */
  ilosc_biletow_max: string = '';

  /** kolejność tabeli */
  ilosc_biletow_wolnych: string = '';

  /** kolejność tabeli */
  ilosc_biletow_wykorzystanych: string = '';

  /** kolejność tabeli */
  ilosc_biletow_sprzedanych: string = '';

  /** ??? poprawny typ? */
  tag_01: string = '';
  /** ??? poprawny typ? */
  tag_02: string = '';
  /** ??? poprawny typ? */
  tag_03: string = '';
  /** ??? poprawny typ? */
  tag_04: string = '';
  /** ??? poprawny typ? */
  tag_05: string = '';
  /** ??? poprawny typ? */
  tag_06: string = '';
  /** ??? poprawny typ? */
  tag_07: string = '';
  /** ??? poprawny typ? */
  tag_08: string = '';
  /** ??? poprawny typ? */
  tag_09: string = '';
  /** ??? poprawny typ? */
  tag_10: string = '';

  constructor(data?: any) {
    if (data) {
      this['sesja_nr'] = data['sesja_nr'];
      this['opis'] = data['opis'];
      this['data'] = data['data'];
      this['data_godz_min_od'] = data['data_godz_min_od'];
      this['data_godz_min_do'] = data['data_godz_min_do'];
      this['godz_min_od'] = data['godz_min_od'];
      this['godz_min_do'] = data['godz_min_do'];
      this['godz_od'] = data['godz_do'];
      this['min_od'] = data['min_od'];
      this['godz_do'] = data['godz_do'];
      this['min_do'] = data['min_do'];
      this['ilosc_biletow_kontrola'] = data['ilosc_biletow_kontrola'];
      this['ilosc_biletow_wykorzystanych'] = data['ilosc_biletow_wykorzystanych'];
      this['ilosc_biletow_max'] = data['ilosc_biletow_max'];
      this['ilosc_biletow_wolnych'] = data['ilosc_biletow_wolnych'];
      this['ilosc_biletow_sprzedanych'] = data['ilosc_biletow_sprzedanych'];
      this['tag_01'] = data['tag_01'];
      this['tag_02'] = data['tag_02'];
      this['tag_03'] = data['tag_03'];
      this['tag_04'] = data['tag_04'];
      this['tag_05'] = data['tag_05'];
      this['tag_06'] = data['tag_06'];
      this['tag_07'] = data['tag_07'];
      this['tag_08'] = data['tag_08'];
      this['tag_09'] = data['tag_09'];
      this['tag_10'] = data['tag_10'];
    }
  }
}

export class SessionSum {
  /** pon - pt, czy sob, niedz */
  _dzien_tygodnia: number = 0;

  /** data do wyswietlenia */
  data: string = '';

  /** dzien tygodnia do wyswietlenia */
  dzien: string = '';

  /** */
  dzienTygodnia: number = 0;

  /** ilosc kontroli do wyswietlenia */
  kontrola: number = 0;

  /** ilosc sprzedanych sesji tego typu */
  sprzedano: number = 0;

  /** ??? poprawny typ? */
  tag_01: string = '';
  /** ??? poprawny typ? */
  tag_02: string = '';
  /** ??? poprawny typ? */
  tag_03: string = '';

  /** ile ludzi weszlo do wyswietlenia */
  weszlo: number = 0;

  constructor(data?: any) {
    if (data) {
      this['_dzien_tygodnia'] = data['_dzien_tygodnia'];
      this['data'] = data['data'];
      this['dzien'] = data['dzien'];
      this['dzienTygodnia'] = data['dzienTygodnia'];
      this['kontrola'] = data['kontrola'];
      this['sprzedano'] = data['sprzedano'];
      this['tag_01'] = data['tag_01'];
      this['tag_02'] = data['tag_02'];
      this['tag_03'] = data['tag_03'];
      this['weszlo'] = data['weszlo'];
    }
  }
}

export class Invoice {
  /** nazwa asortymentu */
  asort_nazwa: string = '';

  /** cena asortymentu */
  cena: string = '';

  /** nr zakupu */
  dok_nr: number = 0;

  /** ilosc zakupionych asortymentow */
  ilosc: string = '';

  /** ??? poprawny typ? */
  tag_01: string = '';
  /** ??? poprawny typ? */
  tag_02: string = '';
  /** ??? poprawny typ? */
  tag_03: string = '';

  constructor(data?: any) {
    if (data) {
      this['asort_nazwa'] = data['asort_nazwa'];
      this['cena'] = data['cena'];
      this['dok_nr'] = data['dok_nr'];
      this['ilosc'] = data['ilosc'];
      this['tag_01'] = data['tag_01'];
      this['tag_02'] = data['tag_02'];
      this['tag_03'] = data['tag_03'];
    }
  }
}

export class webTickets {
  /** sesje - do wyśietlenia na stronie internetowej */
  result: Ticket[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class SessionsSum {
  /** sesje - do wyśietlenia po lewej */
  result: SessionSum[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class Invoices {
  /** sesje - do wyśietlenia po lewej */
  result: Invoice[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class PDFData {
  /** sesje - do wyśietlenia na stronie internetowej */

  asort_nazwa: string = '';
  bilet_id: number = 0;
  data_godz_od: string = '';
  dok_nr: number = 0;
  ilosc: number = 0;
  constructor(data?: any) {
    if (data) {
      this['asort_nazwa'] = data['asort_nazwa'];
      this['bilet_id'] = data['bilet_id'];
      this['data_godz_od'] = data['data_godz_od'];
      this['dok_nr'] = data['dok_nr'];
      this['ilosc'] = data[' ilosc'];
    }
  }
}

export class vscPayment {
  /** platnosc id */
  id: string = '';

  /** url do platnosci */
  redirectUrl: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['redirectUrl'] = data['redirectUrl'];
    }
  }
}

export class vscPayments {
  /** platnosci CahsBill */
  result: vscPayment[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class ticketHeader { /*złe opisy*/
  /** grupa id */
  brutto: string = '';

  /** nagłówek tabeli */
  data_wyst: string = '';

  /** nagłówek tabeli */
  dok_nr: string = '';

  /** kolejność tabeli */
  kontr_nazwa: string = '';

  /** grupa id */
  operator_id: string = '';

  /** nagłówek tabeli */
  sp_zaplaty: string = '';

  /** kolejność tabeli */
  stolik_id: string = '';

  /** kolejność tabeli */
  zamkniety: number = 0;

  constructor(data?: any) {
    if (data) {
      this['brutto'] = data['brutto'];
      this['data_wyst'] = data['data_wyst'];
      this['dok_nr'] = data['dok_nr'];
      this['kontr_nazwa'] = data['kontr_nazwa'];
      this['operator_id'] = data['operator_id'];
      this['sp_zaplaty'] = data['sp_zaplaty'];
      this['stolik_id'] = data['stolik_id'];
      this['zamkniety'] = data['zamkniety'];

    }
  }
}

export class Surnames {
  /** lista wyszukanych nazwisk */
  result: Surname[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class Surname {
  /** numer e-karty - id */
  e_karta: string = '';

  logo: string = '';

  /** nazwisko klienta */
  nazwisko: string = '';

  /** uwagi do klienta */
  info: string = '';

  /** telefon klienta */
  telefon: string = '';

  saldo: string = '';

  wplata: string = '';

  realizacja: string = '';

  constructor(data?: any) {
    if (data) {
      this['e_karta'] = data['e_karta'];
      this['logo'] = data['logo'];
      this['nazwisko'] = data['nazwisko'];
      this['info'] = data['info'];
      this['telefon'] = data['telefon'];
      this['saldo'] = data['saldo'];
      this['wplata'] = data['wplata'];
      this['realizacja'] = data['realizacja'];
    }
  }
}

export class PassHistory {
  /** lista wyszukanych nazwisk */
  result: Pass[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class Pass {
  /** numer zakupu */
  dok_nr: string = '';

  /**  */
  dt: string = '';

  /** numer e-karty */
  e_karta: string = '';

  /** numer e-karty */
  ekarta: string = '';

  /** ile wejsc wykorzystano */
  realizacja: string = '';

  /** ile wejsc zostalo */
  saldo: string = '';

  kredyt: string = '';
  sesja_data: string = '';
  sesja_id: number = 0;
  status_id: number = 0;
  status_opis: string = '';
  wplacono: string = '';

  constructor(data?: any) {
    if (data) {
      this['dok_nr'] = data['dok_nr'];
      this['dt'] = data['dt'];
      this['e_karta'] = data['e_karta'];
      this['ekarta'] = data['ekarta'];
      this['realizacja'] = data['realizacja'];
      this['saldo'] = data['saldo'];
      this['kredyt'] = data['kredyt'];
      this['sesja_data'] = data[' sesja_data'];
      this['sesja_id'] = data['sesja_id'];
      this['status_id'] = data['status_id'];
      this['status_opis'] = data['status_opis'];
      this['wplacono'] = data['wplacono'];
    }
  }
}

export class ticketHeaders {
  result: ticketHeader[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class OrderAsort {
  /**  */
  stawka_vat: string = '';

  /** id magazynu */
  mag_id: string = '';

  /** id asortymentu */
  asort_id: string = '';

  /**  */
  asort_nazwa: string = '';

  /** opcja / cena za miejsce */
  cena: string = '';

  constructor(data?: any) {
    if (data) {
      this['stawka_vat'] = data['stawka_vat'];
      this['mag_id'] = data['mag_id'];
      this['asort_id'] = data['asort_id'];
      this['asort_nazwa'] = data['asort_nazwa'];
      this['cena'] = data['cena'];
    }
  }
}

export class Kontakt1 {
  /**  */
  domena: string = '';

  /** kontakt do klienta w HTML */
  info: string = '';

  /**  */
  kontakt_adres: string = '';

  /**  */
  kontakt_e_mail: string = '';

  /**  */
  kontakt_fax: string = '';

  /**  */
  kontakt_gps: string = '';

  /**  */
  kontakt_telefon: string = '';

  /**  */
  opis: string = '';

  constructor(data?: any) {
    if (data) {
      this['domena'] = data['domena'];
      this['info'] = data['info'];
      this['kontakt_adres'] = data['kontakt_adres'];
      this['kontakt_e_mail'] = data['kontakt_e_mail'];
      this['kontakt_fax'] = data['kontakt_fax'];
      this['kontakt_gps'] = data['kontakt_gps'];
      this['kontakt_telefon'] = data['kontakt_telefon'];
      this['opis'] = data['opis'];
    }
  }
}

export class Kontakt {
  result: Kontakt1[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class payStatus {
  /**  */
  id: string = '';

  /**  */
  paymentChannel: string = '';

  /**  */
  amount: Amount = new Amount();

  /**  */
  requestedAmount: requestedAmount = new requestedAmount();

  /**  */
  title: string = '';

  /**  */
  description: string = '';

  /**  */
  personalData: personalData = new personalData();

  /**  */
  additionalData: string = '';

  /**  */
  status: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['paymentChannel'] = data['paymentChannel'];
      this['amount'] = data['amount'];
      this['requestedAmount'] = data['requestedAmount'];
      this['title'] = data['title'];
      this['description'] = data['description'];
      this['personalData'] = data['personalData'];
      this['additionalData'] = data['additionalData'];
      this['status'] = data['status'];
    }
  }
}

export class payTest1 {
  /**  */
  id: string = '';

  /**  */
  availableCurrencies: string[] = [];

  /**  */
  name: string = '';

  /**  */
  description: string = '';

  /**  */
  logoUrl: string = '';

  constructor(data?: any) {
    if (data) {
      this['id'] = data['id'];
      this['availableCurrencies'] = data['availableCurrencies'];
      this['name'] = data['name'];
      this['description'] = data['description'];
      this['logoUrl'] = data['logoUrl'];
    }
  }
}

export class Amount {
  /**  */
  value: number = 0;

  /**  */
  currencyCode: string = '';

  constructor(data?: any) {
    if (data) {
      this['value'] = data['value'];
      this['currencyCode'] = data['currencyCode'];
    }
  }
}

export class requestedAmount {
  /**  */
  value: number = 0;

  /**  */
  currencyCode: string = '';

  constructor(data?: any) {
    if (data) {
      this['value'] = data['value'];
      this['currencyCode'] = data['currencyCode'];
    }
  }
}

export class personalData {
  /**  */
  firstName: string = '';

  /**  */
  surname: string = '';

  /**  */
  email: string = '';

  /**  */
  country: string = '';

  /**  */
  city: string = '';

  /**  */
  postcode: string = '';

  /**  */
  street: string = '';

  /**  */
  house: string = '';

  /**  */
  flat: string = '';

  /**  */
  ip: string = '';

  constructor(data?: any) {
    if (data) {
      this['firstName'] = data['firstName'];
      this['surname'] = data['surname'];
      this['email'] = data['email'];
      this['country'] = data['country'];
      this['city'] = data['city'];
      this['postcode'] = data['postcode'];
      this['street'] = data['street'];
      this['house'] = data['house'];
      this['flat'] = data['flat'];
      this['ip'] = data['ip'];
    }
  }
}

export class PortalInfo {
  /** pokoje - do wyśietlenia na stronie internetowej */
  result: Info[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}


export class Info {

  domena: string = '';
  googleMaps: string = '';
  info: string = '';
  kontaktAdres: string = '';
  kontaktEmail: string = '';
  kontaktFax: string = '';
  kontaktGps: string = '';
  kontaktTelefon: string = '';
  materialuiZestawNr: string = '';
  opis: string = '';
  payWeb: string = ''; 
  preautoryzacja: string = ''; 

  constructor(data?: any) {
    if (data) {
      this['domena'] = data['domena'];
      this['googleMaps'] = data['googleMaps'];
      this['info'] = data['info'];
      this['kontaktAdres'] = data['kontaktAdres'];
      this['kontaktEmail'] = data['kontaktEmail'];
      this['kontaktFax'] = data['kontaktFax'];
      this['kontaktGps'] = data['kontaktGps'];
      this['kontaktTelefon'] = data['kontaktTelefon'];
      this['materialuiZestawNr'] = data['materialuiZestawNr'];
      this['opis'] = data['opis'];
      this['payWeb'] = data['payWeb'];
      this['preautoryzacja'] = data['preautoryzacja'];
    }
  }
}

export class Fonts {
  result: Font[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}


export class Font {
  czcionkaId: number = 0;
  fontSize: number = 0;
  opis: string = '';
  fontWeight: string = '';
  color: string = '';
  fontFamily: string = '';
  aktywna: number = 0;

  constructor(data?: any) {
    if (data) {
      this['czcionkaId'] = data['czcionkaId'];
      this['fontSize'] = data['fontSize'];
      this['fontWeight'] = data['fontWeight'];
      this['color'] = data['color'];
      this['fontFamily'] = data['fontFamily'];
      this['aktywna'] = data['aktywna'];
      this['opis'] = data['opis'];
    }
  }
}
// Generated by https://quicktype.io

export class Nip {
  nipPytanie: string = '';
  nipOdpowiedz: string = '';
  nazwa: string = '';
  miejscowosc: string = '';
  kodPocztowy: string = '';
  ulica: string = '';
  dt: string = '';

  constructor(data?: any) {
    if (data) {
      this['nipPytanie'] = data['nipPytanie'];
      this['nipOdpowiedz'] = data['nipOdpowiedz'];
      this['nazwa'] = data['nazwa'];
      this['miejscowosc'] = data['miejscowosc'];
      this['kodPocztowy'] = data['kodPocztowy'];
      this['ulica'] = data['ulica'];
      this['dt'] = data['dt'];
    }
  }
}

// Generated by https://quicktype.io

export class AsortMenuWiersze {
  //grupy z asortymentem skojarzone z menu items pokazywane w srodkowym panelu
  result: AsortMenuWiersz[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class AsortMenuWiersz {
  menu_id: number = 0;
  menu_lp: number = 0;
  grupa_id: number = 0;
  grupa_opis: string = '';
  kolejnosc: number = 0;
  priorytet: string = "";

  constructor(data?: any) {
    if (data) {
      this['menu_id'] = data['menu_id'];
      this['menu_lp'] = data['menu_lp'];
      this['grupa_id'] = data['grupa_id'];
      this['grupa_opis'] = data['grupa_opis'];
      this['kolejnosc'] = data['kolejnosc'];
      this['priorytet'] = data['priorytet'];
    }
  }
}

// Generated by https://quicktype.io

export class AsortGrupyWiersze {
  result: AsortGrupyWiersz[] = [];

  constructor(data?: any) {
    if (data) {
      this['result'] = data['result'];
    }
  }
}

export class AsortGrupyWiersz {
  grupa_id: number = 0;
  grupa_lp: number = 0;
  mag_id: number = 0;
  asort_id: number = 0;
  asort_nazwa: string = '';
  jm: string = '';
  vat_stawka: string = '';
  cena: string = '';
  waluta: string = '';
  kolejnosc: number = 0;
  tag_01: string = '';
  tag_02: string = '';
  tag_03: string = '';
  tag_04: string = '';
  tag_05: string = '';
  tag_06: string = '';
  tag_07: string = '';
  tag_08: string = '';
  tag_09: string = '';
  tag_10: string = '';
  tag_11: string = '';
  tag_12: string = '';
  tag_13: string = '';
  tag_14: string = '';
  tag_15: string = '';
  foto: string = '';
  info: string = '';
  nazwa_do_zm: number = 0;
  cena_do_zm: number = 0;
  priorytet: number = 0;
  menu_id: number = 0;
  bold: boolean = true;
  

  constructor(data?: any) {
    if (data) {
      this['grupa_id'] = data['grupa_id'];
      this['grupa_lp'] = data['grupa_lp'];
      this['mag_id'] = data['mag_id'];
      this['asort_id'] = data['asort_id'];
      this['asort_nazwa'] = data['asort_nazwa'];
      this['jm'] = data['jm'];
      this['vat_stawka'] = data['vat_stawka'];
      this['cena'] = data['cena'];
      this['waluta'] = data['waluta'];
      this['kolejnosc'] = data['kolejnosc'];
      this['kolejnosc'] = data['kolejnosc'];
      this['tag_01'] = data['tag_01'];
      this['tag_02'] = data['tag_02'];
      this['tag_03'] = data['tag_03'];
      this['tag_04'] = data['tag_04'];
      this['tag_05'] = data['tag_05'];
      this['tag_06'] = data['tag_06'];
      this['tag_07'] = data['tag_07'];
      this['tag_08'] = data['tag_08'];
      this['tag_09'] = data['tag_09'];
      this['tag_10'] = data['tag_10'];
      this['tag_11'] = data['tag_11'];
      this['tag_12'] = data['tag_12'];
      this['tag_13'] = data['tag_13'];
      this['tag_14'] = data['tag_14'];
      this['tag_15'] = data['tag_15'];
      this['foto'] = data['foto'];
      this['info'] = data['info'];
      this['nazwa_do_zm'] = data['nazwa_do_zm'];
      this['cena_do_zm'] = data['cena_do_zm'];
      this['priorytet'] = data['priorytet'];
      this['menu_id'] = data['menu_id'];
      this['bold'] = data['bold'];
    }
  }
}

export class Result<T> {
  result: T[] = [];

  constructor(data?: any) {
    if (data) {
      this.result = data.result;
    }
  }
}

// Generated by https://quicktype.io

//PM 2021-03-17
export class WWWSprzedazInfo {
  www_sprzedaz_odswiez_dane: number = 0;
  www_sprzedaz_zamkniecieAuto: number = 0;
  www_sprzedaz_operator_id: number = 0;
  www_sprzedaz_kwota_limit_max: number = 0;
  www_sprzedaz_kwota_limit_min: number = 0;
  www_sprzedaz_ilosc_limit: number = 0;
  www_sprzedaz_sposob_zaplaty: string = '';
  www_sprzedaz_error: number = 0;
  www_sprzedaz_error_info: string = '';
  www_sprzedaz_czas_oczekiwania: number = 0;
  www_sprzedaz_czas_oczekiwania_info: string = '';
  www_sprzedaz_dostawa_teren_opis: string = '';
  dane_aktualizacja_dt: string = '';
  dane_aktualizacja_co: number = 0;
  www_zam_dzien1: string = '';
  www_zam_dzien1OK: string = '';
  www_zam_dzien2: string = '';
  www_zam_dzien2OK: string = '';
  www_zam_dzien3: string = '';
  www_zam_dzien3OK: string = '';
  www_zam_dzien4: string = '';
  www_zam_dzien4OK: string = '';
  www_zam_dzien5: string = '';
  www_zam_dzien5OK: string = '';
  www_zam_dzien6: string = '';
  www_zam_dzien6OK: string = '';
  www_zam_dzien7: string = '';
  www_zam_dzien7OK: string = '';

  constructor(data?: any) {
    if (data) {
      this.www_sprzedaz_odswiez_dane = data.www_sprzedaz_odswiez_dane;
      this.www_sprzedaz_zamkniecieAuto = data.www_sprzedaz_zamkniecieAuto;
      this.www_sprzedaz_operator_id = data.www_sprzedaz_operator_id;
      this.www_sprzedaz_kwota_limit_max = data.www_sprzedaz_kwota_limit_max;
      this.www_sprzedaz_kwota_limit_min = data.www_sprzedaz_kwota_limit_min;
      this.www_sprzedaz_ilosc_limit = data.www_sprzedaz_ilosc_limit;
      this.www_sprzedaz_sposob_zaplaty = data.www_sprzedaz_sposob_zaplaty;
      this.www_sprzedaz_error = data.www_sprzedaz_error;
      this.www_sprzedaz_error_info = data.www_sprzedaz_error_info;
      this.www_sprzedaz_czas_oczekiwania = data.www_sprzedaz_czas_oczekiwania;
      this.www_sprzedaz_czas_oczekiwania_info = data.www_sprzedaz_czas_oczekiwania_info;
      this.www_sprzedaz_dostawa_teren_opis = data.www_sprzedaz_dostawa_teren_opis;
      this.dane_aktualizacja_dt = data.dane_aktualizacja_dt;
      this.dane_aktualizacja_co = data.dane_aktualizacja_co;
      this.www_zam_dzien1 = data.www_zam_dzien1;
      this.www_zam_dzien1OK = data.www_zam_dzien1OK;
      this.www_zam_dzien2 = data.www_zam_dzien2;
      this.www_zam_dzien2OK = data.www_zam_dzien2OK;
      this.www_zam_dzien3 = data.www_zam_dzien3;
      this.www_zam_dzien3OK = data.www_zam_dzien3OK;
      this.www_zam_dzien4 = data.www_zam_dzien4;
      this.www_zam_dzien4OK = data.www_zam_dzien4OK;
      this.www_zam_dzien5 = data.www_zam_dzien5;
      this.www_zam_dzien5OK = data.www_zam_dzien5OK;
      this.www_zam_dzien6 = data.www_zam_dzien6;
      this.www_zam_dzien6OK = data.www_zam_dzien6OK;
      this.www_zam_dzien7 = data.www_zam_dzien7;
      this.www_zam_dzien7OK = data.www_zam_dzien7OK;
    }
  }
}

// Generated by https://quicktype.io

export class AsortWWWMenuNagl {
  menu_id: number = 0;
  opis: string = '';
  kolejnosc: number = 0;
  zamowienie_min_ilosc_pozycji: number = 0;

  constructor(data?: any) {
    if (data) {
      this.menu_id = data.menu_id;
      this.opis = data.opis;
      this.kolejnosc = data.kolejnosc;
      this.zamowienie_min_ilosc_pozycji = data.zamowienie_min_ilosc_pozycji;
    }
  }
}

export class VatHeder {
  adres: string = '';
  algVat: string = '';
  brutto: string = '';
  dataSprz: string = '';
  dataWyst: string = '';
  doZaplaty: string = '';
  dokNr: string = '';
  //dokSprzedazyOpis: string = '';
  dokTypNrWydruk: string = '';
  infoF: string = '';
  kontrId: string = '';
  kontrNazwa: string = '';
  lookUpDokTypNrWydrukOpis: string = '';
  lookUpOperatorOpis: string = '';
  lookUpSpZaplatyOpis: string = '';
  netto: string = '';
  nip: string = '';
  operatorId: string = '';
  osobaOdb: string = '';
  pobytDo: string = '';
  pobytOd: string = '';
  pokoj: string = '';
  przydzial: string = '';
  spZaplaty: string = '';
  //spZaplatyOpis: string = '';
  sprzedazOdroczona: string = '';
  terminDt: string = '';
  vat: string = '';
  zaliczka: string = '';
  zamData: string = '';
  zamFirma: string = '';
  zamFirmaId: string = '';
  zamLokal: string = '';
  zamOsobaId: string = '';
  zamkniety: string = '';

  constructor(data?: any) {
    if (data) {
      this.adres = data.adres;
      this.algVat = data.algVat;
      this.brutto = data.brutto;
      this.dataSprz = data.dataSprz;
      this.dataWyst = data.dataWyst;
      this.doZaplaty = data.doZaplaty;
      this.dokNr = data.dokNr;
      //this.dokSprzedazyOpis = data.dokSprzedazyOpis;
      this.dokTypNrWydruk = data.dokTypNrWydruk;
      this.infoF = data.infoF;
      this.kontrId = data.kontrId;
      this.kontrNazwa = data.kontrNazwa;
      this.lookUpDokTypNrWydrukOpis = data.lookUpDokTypNrWydrukOpis;
      this.lookUpOperatorOpis = data.lookUpOperatorOpis;
      this.lookUpSpZaplatyOpis = data.lookUpSpZaplatyOpis;
      this.netto = data.netto;
      this.nip = data.nip;
      this.operatorId = data.operatorId;
      this.osobaOdb = data.osobaOdb;
      this.pobytDo = data.pobytDo;
      this.pobytOd = data.pobytOd;
      this.pokoj = data.pokoj;
      this.przydzial = data.przydzial;
      this.spZaplaty = data.spZaplaty;
      //this.spZaplatyOpis = data.spZaplatyOpis;
      this.sprzedazOdroczona = data.sprzedazOdroczona;
      this.terminDt = data.terminDt;
      this.vat = data.vat;
      this.zaliczka = data.zaliczka;
      this.zamData = data.zamData;
      this.zamFirma = data.zamFirma;
      this.zamFirmaId = data.zamFirmaId;
      this.zamLokal = data.zamLokal;
      this.zamOsobaId = data.zamOsobaId;
      this.zamkniety = data.zamkniety;
    }
  }
}

export class VatTableVat {
  brutto: string = '';
  dokNr: string = '';
  netto: string = '';
  przydzial: string = '';
  vat: string = '';
  vatStawka: string = '';


  constructor(data?: any) {
    if (data) {
      this.brutto = data.brutto;
      this.dokNr = data.dokNr;
      this.netto = data.netto;
      this.przydzial = data.przydzial;
      this.vat = data.vat;
      this.vatStawka = data.vatStawka;
    }
  }
}

export class VatTableRow {
  asortId: string = '';
  asortNazwa: string = '';
  brutto: string = '';
  cenaBrutto: string = '';
  cenaNetto: string = '';
  dokLp: string = '';
  dokNr: string = '';
  ilosc: string = '';
  jm: string = '';
  magId: string = '';
  netto: string = '';
  przydzial: string = '';
  vat: string = '';
  vatStawka: string = '';


  constructor(data?: any) {
    if (data) {
      this.asortId = data.asortId;
      this.asortNazwa = data.asortNazwa;
      this.brutto = data.brutto;
      this.cenaBrutto = data.cenaBrutto;
      this.cenaNetto = data.cenaNetto;
      this.dokLp = data.dokLp;
      this.dokNr = data.dokNr;
      this.ilosc = data.ilosc;
      this.jm = data.jm;  
      this.magId = data.magId;
      this.netto = data.netto;
      this.przydzial = data.przydzial;
      this.vat = data.vat;
      this.vatStawka = data.vatStawka;
    }
  }
}

export class VatTableRowFromTo {
  asortymenty: string = '';
  brutto: string = '';
  dataWyst: string = '';
  dokNr: string = '';
  opis1: string = '';
  opis2: string = '';
  opis3: string = '';
  opis4: string = '';
  przydzial: string = '';
  zamkniety: string = '';



  constructor(data?: any) {
    if (data) {
      this.asortymenty = data.asortymenty;
      this.brutto = data.brutto;
      this.dataWyst = data.dataWyst;
      this.dokNr = data.dokNr;
      this.opis1 = data.opis1;
      this.opis2 = data.opis2;
      this.opis3 = data.opis3;
      this.opis4 = data.opis4;  
      this.przydzial = data.przydzial;
      this.zamkniety = data.zamkniety;
    }
  }
}

export class VatInstalacja {
  naglLinia1: string = '';
  naglLinia2: string = '';
  naglLinia3: string = '';
  naglLinia4: string = '';
  naglLinia5: string = '';
  przydzial: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.naglLinia1 = data.naglLinia1;
      this.naglLinia2 = data.naglLinia2;
      this.naglLinia3 = data.naglLinia3;
      this.naglLinia4 = data.naglLinia4;
      this.naglLinia5 = data.naglLinia5;
      this.przydzial = data.przydzial;
    }
  }
}

export class VatNotes {
  dokNr: string = '';
  liniaNr: string = '';
  przydzial: string = '';
  tekst: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dokNr = data.dokNr;
      this.liniaNr = data.liniaNr;
      this.przydzial = data.przydzial;
      this.tekst = data.tekst;
    }
  }
}

export class VatDokNr {
  dokNr: string = '';
  przydzial: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.dokNr = data.dokNr;
      this.przydzial = data.przydzial;
    }
  }
}

export class UserData {
  zamOsobaId: string = "";
  zamFirmaId: string = "";
  zamOddzialId: string = "";
  nazwisko: string = "";
  telefon: string = "";
  uprawnieniaPoziom: string = "";
  firmaOpis: string = "";
  oddzialOpis: string = "";
  oddzialAdres: string = "";
  dostawaGodzMinuta: string = "";
  dostawaJakiDzien: string = "";
  payweb: string = "";
  logo: string = '';
  timestamp: string = ""

  constructor(data?: any) {
    if (data) {
      this.zamOsobaId = data.zamOsobaId;
      this.zamFirmaId = data.zamFirmaId;
      this.zamOddzialId = data.zamOddzialId;
      this.nazwisko = data.nazwisko;
      this.telefon = data.telefon;
      this.uprawnieniaPoziom = data.uprawnieniaPoziom;
      this.firmaOpis = data.firmaOpis;  
      this.oddzialOpis = data.oddzialOpis;
      this.oddzialAdres = data.oddzialAdres;
      this.dostawaGodzMinuta = data.dostawaGodzMinuta;
      this.dostawaJakiDzien = data.dostawaJakiDzien;
      this.payweb = data.payweb;
      this.logo = data.logo;
      this.timestamp = data.timestamp;
    }
  }
}

export class ZamOsobaInfoOK {
  zamFirmaDostawaOK: string = '';
  zamFirmaLokalOK: string = '';
  zamInfoOK: string = '';
  zamOddzialDostawaOK: string = '';
  zamOsobaDostawyOK: string = '';
  zamOsobaIdOK: string = '';
  zamOsobaZaplatyOK: string = '';
 
  constructor(data?: any) {
    if (data) {
      this.zamFirmaDostawaOK = data.zamFirmaDostawaOK;
      this.zamFirmaLokalOK = data.zamFirmaLokalOK;
      this.zamInfoOK = data.zamInfoOK;
      this.zamOddzialDostawaOK = data.zamOddzialDostawaOK;
      this.zamOsobaDostawyOK = data.zamOsobaDostawyOK;
      this.zamOsobaIdOK = data.zamOsobaIdOK;
      this.zamOsobaZaplatyOK = data.zamOsobaZaplatyOK;
    }
  }
}

export class BlobService {

static dajBlob1(
    params: {
      aJSON: DajblobDodaj
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<Blob>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/obiekt/dajBlob1';

      configs.url = url;
      let data = { ...params['aJSON'] };
      //configs.params = data
      configs.data = data;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export type DajblobDodaj = {
  hotelId: string;
  ajsonBlob: string;
  ajsonRekNr: number;
  ajsonWebService: string;
  opis: string;
}

export class Blob {
  opis: string = '';
  ajsonRekNr: string = '';
  ajsonBlob: string = '';
  ajsonWebService: string = '';

  constructor(data?: any) {
    if (data) {
      this.opis = data.opis;
      this.ajsonRekNr = data.ajsonRekNr;
      this.ajsonBlob = data.ajsonBlob;
      this.ajsonWebService = data.ajsonWebService;
    }
  }
}

export class fotoService {

  /**
   * galeria zdjęć
   */
  static getGallery(
    params: {
      /**  */
      hotelId: string;
      /**  */
      rodzPokoi: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
      let url = serverUrl() + '/hotel/image/galeria';

      configs.url = url;
      configs.params = { hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'] };
      let data = null;

      configs.data = data;
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  static postFavourite(
    params: {
      hotelId: string;
      rodzPokoi: string;
      kategoria: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/ustawRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = {
        hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'],
        kategoria: params['kategoria'], nazwaPliku: params['nazwaPliku']
      }
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      configs.data = data;
      configs.params = data;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static deleteFoto(
    params: {
      hotelId: string;
      rodzPokoi: string;
      kategoria: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/kasujRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params.hotelId, rodzPokoi: params.rodzPokoi, kategoria: params.kategoria, nazwaPliku: params.nazwaPliku }

      //configs.data = data;
      //configs.params = data;
      let fd = new FormData()
      fd.append("hotelId", params['hotelId'])
      fd.append("rodzPokoi", params['rodzPokoi'])
      fd.append("kategoria", params['kategoria'])
      fd.append("nazwaPliku", params['nazwaPliku'])

      configs.data = fd;
      configs.params = fd;


      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static deleteWspolny(
    params: {
      hotelId: string;
      nazwaPliku: string;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      };
      let url = serverUrl() + '/hotel/image/kasujWspolne';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      let data = { hotelId: params.hotelId, nazwaPliku: params.nazwaPliku }

      //configs.data = data;
      //configs.params = data;
      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])

      fd.append("nazwaPliku", params['nazwaPliku'])
      configs.data = data;
      configs.params = data;

      console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          console.log(err)
          reject(err);
        });
    });
  }

  static postAddPokojFoto(
    params: {
      hotelId: string;
      rodzPokoi: string;
      fotoGlowne: string;
      kategoria: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajRodzPokoi';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], rodzPokoi: params['rodzPokoi'], 
      //  kategoria: params['kategoria'], fotoGlowne: params['fotoGlowne'],  plik: params['plik'] }
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      //configs.data = data;
      //configs.params = data;
      //configs.params = data;

      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("rodzPokoi", params['rodzPokoi'])
      fd.append("fotoGlowne", params['fotoGlowne'])
      fd.append("kategoria", params['kategoria'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static postAddWspolneFoto(
    params: {
      hotelId: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajWspolne';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], plik: params['plik'],}
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  

      //configs.params = data;
      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static postAddStartFoto(
    params: {
      hotelId: string;
      plik: any;
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'post' };
      configs.headers = {
        ...options.headers,
        'Content-Type': `multipart/form-data; `,
        'Accept': '*/*'
      };
      let url = serverUrl() + '/hotel/image/dodajStartowe';

      configs.url = url;
      //configs.params = JSON.stringify({hotelId: params['hotelId'], mobileNr: params['mobileNr'], text: params['text']})
      //let data = { hotelId: params['hotelId'], plik: params['plik'],}
      //let data = JSON.stringify({ hotelId: params['hotelId'], mobileNr: params['mobileNr'], token: params['token'] })  
      //configs.data = data;
      //configs.params = data;
      //configs.params = data;

      let fd = new FormData()

      fd.append("hotelId", params['hotelId'])
      fd.append("plik", params['plik'])
      configs.data = fd;
      configs.params = fd;

      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export class telefonService {

  static dajPrefiksy(
    params: {
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<Prefiks>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/dajSmsPrefiksy';
      configs.url = url;

      configs.params = { };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajSmsGsmPlPrefiksy(
    params: {
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<PrefiksPl>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/dajSmsGsmPlPrefiksy';
      configs.url = url;

      configs.params = { };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static dajCzarnaListe(
    params: {
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<{tel: string}>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };

      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/dajSmsCzarnaListe';
      configs.url = url;

      configs.params = { };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static sprawdzNrTelefonu(
    params: {
      nrTelefonu: string,
    } = <any>{},
    options: IRequestOptions = {}
  ): Promise<Result<string>> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = { ...options, method: 'get' };
      configs.headers = {
        ...options.headers,
        'Content-Type': 'application/json'
      };
    
      //const url = serverUrl() + '/obiekt/dajGrafikObiekt';
      const url = 'https://vsc24.net/vscSms/sms/sprawdzNrTelefonu';
      configs.url = url;

      configs.params = { nrTelefonu: params.nrTelefonu };
      let data = null;

      configs.data = data;
      //console.log(configs)
      axios(configs)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}

export type Prefiks = {
  prefiks: string,
  opis: string,
  domena: string,
  lbCyfr: string,
}

export type PrefiksPl = {
  prefiks: string,
  opis: string,
}


export class MapaOpis {
  id: string = '';
  opis: string = '';
  regionId: string = '';
  krainaId: string = '';
  obszarId: string = '';
  mapaOpisWspGoraSzerokosc: string = '';
  mapaOpisWspDolSzerokosc: string = '';
  mapaOpisWspLewaDlugosc: string = '';
  mapaOpisWspPrawaDlugosc: string = '';
  mapaOpisLiniaStartWspSzerokosc: string = '';
  mapaOpisLiniaStartWspDlugosc: string = '';
  mapaOpisLiniaStopWspSzerokosc: string = '';
  mapaOpisLiniaStopWspDlugosc: string = '';
  mapaOpisFontKolor: string = '';
  mapaOpisTloKolor: string = '';
  mapaOpisFontSize1920: string = '';
  mapaOpisFontSize1600: string = '';
  mapaOpisFontSize1280: string = '';
  mapaOpisFontSizeMobile: string = '';
  mapaOpisKomponentNr: string = '';

  constructor(data?: any) {
    if (data) {
      this.id = data.id;
      this.opis = data.opis;
      this.regionId = data.regionId;
      this.krainaId = data.krainaId;
      this.obszarId = data.obszarId;
      this.mapaOpisWspGoraSzerokosc = data.mapaOpisWspGoraSzerokosc;
      this.mapaOpisWspDolSzerokosc = data.mapaOpisWspDolSzerokosc;
      this.mapaOpisWspLewaDlugosc = data.mapaOpisWspLewaDlugosc;
      this.mapaOpisWspPrawaDlugosc = data.mapaOpisWspPrawaDlugosc;
      this.mapaOpisLiniaStartWspSzerokosc = data.mapaOpisLiniaStartWspSzerokosc;
      this.mapaOpisLiniaStartWspDlugosc = data.mapaOpisLiniaStartWspDlugosc;
      this.mapaOpisLiniaStopWspSzerokosc = data.mapaOpisLiniaStopWspSzerokosc;
      this.mapaOpisLiniaStopWspDlugosc = data.mapaOpisLiniaStopWspDlugosc;
      this.mapaOpisFontKolor = data.mapaOpisFontKolor;
      this.mapaOpisTloKolor = data.mapaOpisTloKolor;
      this.mapaOpisFontSize1920 = data.mapaOpisFontSize1920;
      this.mapaOpisFontSize1600 = data.mapaOpisFontSize1600;
      this.mapaOpisFontSize1280 = data.mapaOpisFontSize1280;
      this.mapaOpisFontSizeMobile = data.mapaOpisFontSizeMobile;
      this.mapaOpisKomponentNr = data.mapaOpisKomponentNr;
    }
  }
}

export class RegionCell {
  akcjeWykonaj: number = 0;
  dana1: string = '';
  dana2: string = '';
  dana3: string = '';
  danePokaz: number = 0;
  data: string = '';
  fontKolor: string = '';
  id: number = 0;
  iloscM: number = 0;
  iloscR: number = 0;
  iloscW: number = 0;
  iloscX: number = 0;
  krainaId: number = 0;
  obiektId: string = '';
  obszarId: number = 0;
  osX: number = 0;
  osY: number = 0;
  regionId: number = 0;
  rodzPokoi: string = '';
  tloKolor: string = '';
  typ: number = 0;
  fontBold: number = 0;

  constructor(data?: any) {
    if (data) {
      this.akcjeWykonaj = data.akcjeWykonaj;
      this.dana1 = data.dana1;
      this.dana2 = data.dana2;
      this.dana3 = data.dana3;
      this.danePokaz = data.danePokaz;
      this.data = data.data;
      this.fontKolor = data.fontKolor;
      this.id = data.id;
      this.iloscM = data.iloscM;
      this.iloscR = data.iloscR;
      this.iloscW = data.iloscW;
      this.iloscX = data.iloscX;
      this.krainaId = data.krainaId;
      this.obiektId = data.obiektId;
      this.obszarId = data.obszarId;
      this.osX = data.osX;
      this.osY = data.osY;
      this.regionId = data.regionId;
      this.rodzPokoi = data.rodzPokoi;
      this.tloKolor = data.tloKolor;
      this.typ = data.typ;
      this.fontBold = data.fontBold;
    }
  }
}